<template>
  <!-- -->
  <div class="table-data-4-show">
    <div class="left data">
      <alone-image :src="imageList[0].itemImage" class="table-image"/>
      <alone-text-on-image :data="imageList[0]"/>
    </div>
    <div class="right">
      <div class="t1 data">
        <alone-image :src="imageList[1].itemImage" class="table-image"/>
        <alone-text-on-image :data="imageList[1]"/>
      </div>
      <div class="t2">
        <div class="t3 data">
          <alone-image :src="imageList[2].itemImage" class="table-image"/>
          <alone-text-on-image :data="imageList[2]"/>
        </div>
        <div class="t4 data">
          <alone-image :src="imageList[3].itemImage" class="table-image"/>
          <alone-text-on-image :data="imageList[3]"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import YqIcon from "@/components/YqIcon.vue";
import AloneImage from "@/views/h5/common/sys/miniProgram/setting/component/AloneImage.vue";
import {watch} from "vue";
import AloneTextOnImage from "@/views/h5/common/sys/miniProgram/setting/component/AloneTextOnImage.vue";

export default {
  props: {
    data: {default: () => {
      return {}
    }},
  },
  name: "",
  components: {
    AloneTextOnImage,
    YqIcon, AloneImage
  },
  data() {
    return {
      imageList: [],
    };
  },
  created() {
    this.init();
    watch(() => this.data, () => this.init())
  },
  methods: {
    init() {
      if (!this.data.componentData || !this.data.componentData.length) {
        this.imageList = [
          {text: "", itemImage: "", itemColor: "", itemBackGround: "", path: "", size: ""},
          {text: "", itemImage: "", itemColor: "", itemBackGround: "", path: "", size: ""},
          {text: "", itemImage: "", itemColor: "", itemBackGround: "", path: "", size: ""},
          {text: "", itemImage: "", itemColor: "", itemBackGround: "", path: "", size: ""},
        ];
      } else {
        this.imageList = this.data.componentData;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.table-data-4-show{
  display: flex;
  justify-content: space-between;
  padding: 20px;
  height: 290px;
  background-color: #FFF;
  border-radius: 10px;
  .data{
    box-sizing: border-box;
    border: 1px solid var(--yq-border-color);
    position: relative;
    .table-image{
      width: 100%;
      height: 100%;
    }
    .table-image-empty{
      display: flex;
      justify-content: center;
      height: 100%;
      align-items: center;
      font-size: 50px;
      color: var(--yq-font-color-desc);
    }

  }
  .left{
    width: 250px;
    height: 250px;
  }
  .right{
    width: 380px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .t1{
      height: 115px;
    }
    .t2{
      display: flex;
      justify-content: space-between;
      height: 115px;
      .t3{
        width: 115px;
        height: 100%;
      }
      .t4{
        width: 245px;
        height: 100%;
      }
    }
  }
}
</style>